import { resolveGameRouteSlug } from '@core/utils/resolveGameRouteSlug';

export type GameLaunchMeta = {
  gameId: number;
  gameName: string;
  category: string;
};

/** Registry slug → backend launch payload (gameId path + gameName body). */
export const GAME_LAUNCH_BY_SLUG: Record<string, GameLaunchMeta> = {
  crash: { gameId: 222, gameName: 'skyx', category: 'CRASH' },
  skyx: { gameId: 222, gameName: 'skyx', category: 'CRASH' },
  'sky-x': { gameId: 222, gameName: 'skyx_new', category: 'CRASH' },
  skyx_new: { gameId: 222, gameName: 'skyx_new', category: 'CRASH' },
  'sky-sniffer': { gameId: 222, gameName: 'sky-sniffer', category: 'CRASH' },
  'sky-sniffer-v2': { gameId: 222, gameName: 'sky-sniffer-v2', category: 'CRASH' },
  superdog: { gameId: 222, gameName: 'superdog', category: 'CRASH' },
  'cave-crasher': { gameId: 224, gameName: 'cave-crasher', category: 'CRASH' },
  chickenluck: { gameId: 223, gameName: 'chickenluck', category: 'CRASH' },
  'city-sniffer': { gameId: 226, gameName: 'city-sniffer', category: 'CRASH' },
};

export const DEFAULT_GAME_OPERATOR = 'NGDEV';

export function getGameLaunchMeta(slug: string): GameLaunchMeta | null {
  return (
    GAME_LAUNCH_BY_SLUG[resolveGameRouteSlug(slug)] ??
    GAME_LAUNCH_BY_SLUG[slug] ??
    null
  );
}
